/**
 * Polyfills
 */
/* inspired by https://gist.github.com/1129031 */
/*global document, DOMParser*/
(function (DOMParser) {
    "use strict";

    var proto = DOMParser.prototype,
        nativeParse = proto.parseFromString;

    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if ((new DOMParser()).parseFromString("", "text/html")) {
            // text/html parsing is natively supported
            return;
        }
    } catch (ex) {}

    proto.parseFromString = function (markup, type) {
        if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
            var doc = document.implementation.createHTMLDocument("");
            if (markup.toLowerCase().indexOf('<!doctype') > -1) {
                doc.documentElement.innerHTML = markup;
            }
            else {
                doc.body.innerHTML = markup;
            }
            return doc;
        } else {
            return nativeParse.apply(this, arguments);
        }
    };
}(DOMParser));

/**
 * HTMLCanvasElement.toBlob polyfill
 */
if (!HTMLCanvasElement.toBlob) {
    HTMLCanvasElement.prototype.toBlob = function (callback, type, quality) {
        var uri = this.toDataURL(type, quality);
        var mime = uri.split(',')[0].split(':')[1].split(';')[0];
        var bytes = atob(uri.split(',')[1]);
        var len = bytes.length;
        var buffer = new window.ArrayBuffer(len);
        var arr = new window.Uint8Array(buffer);

        for (var i = 0; i < len; i++) {
            arr[i] = bytes.charCodeAt(i);
        }

        callback(new Blob([arr], { type: mime }));
    };
}
